
<template>
    <span ref="elem" class="text-primary" v-html="icon" data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top" :data-bs-title="state.tooltip"></span>
</template>
<script setup>
import { ref, onMounted, useSlots, reactive, computed } from "vue";
const props = defineProps({
    icon: {
        type: String,
        default: '<i class="fa-sharp fa-solid fa-circle-info"></i>',
    },
    text: {
        type: String,
    },
});

const elem = ref(null)

const state = reactive({
    tooltip: props.text
})

const slots = useSlots();
const defaultSlot = computed(() => slots.default ? slots.default()[0].children : undefined)

onMounted(() => {
    if (defaultSlot.value) {
        state.tooltip = defaultSlot.value;
    }

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
})
</script>
